<div class="h-full w-full" *ngIf="currentDriver$ | async as currentDriver">
  <div
    style="background: linear-gradient(90.45deg, #070707 0%, #3e3e52 100%)"
    class="h-16 flex flex-row justify-between text-white p-3 pb-2"
    [lohiPageTitle]="currentDriver.driverName"
  >
    <div>
      <div class="text-4xl pb-2 font-bold">
        {{ currentDriver.driverName }}
        <ng-container *ngIf="currentDriver.employeeId">&nbsp;({{ currentDriver.employeeId }})</ng-container>
        <a routerLink="./profile">
          <mat-icon
            *ngIf="!currentDriver.allowShiftBooking"
            class="text-red-500"
            matTooltip="Blocked from Booking Shifts"
          >
            event_busy
          </mat-icon>
        </a>
      </div>
      <div class="text-red-500" *ngIf="currentDriver.driverCut == null">
        <span
          tooltip="Used to show a driver how much they can expect to earn. Percent of that load's revenue (less any fuel surcharge) the driver can expect to earn."
          >Driver's Earnings Percentage Needs Set</span
        >
      </div>
      <a class="text-red-500 block" *ngIf="!currentDriver.allowShiftBooking" routerLink="./profile">
        <span>Blocked from Booking Shifts</span>
      </a>
      <a class="text-blue-300" href="tel:{{ currentDriver.phoneNumber }}">{{ currentDriver.phoneNumber | phone }}</a>
      <div>{{ (currentDriverCompletedLoads$ | async)?.length }} lifetime loads delivered</div>
    </div>
    <div class="flex">
      <ng-container *ngIf="userInfo$ | async as userInfo">
        <div *ngIf="userInfo.companyOwnerPhone !== currentDriver.phoneNumber && userInfo.id !== currentDriver.id">
          <button (click)="promptRemoveUser(currentDriver.id)" mat-raised-button color="warn">Remove User</button>
        </div>
      </ng-container>
      <ng-container *ngIf="currentPendingDriver$ | async as currentPendingDriver">
        <button (click)="removeUser(currentPendingDriver.id)" mat-raised-button color="warn">
          Remove Pending User
        </button>
      </ng-container>
    </div>
  </div>
  <nav mat-tab-nav-bar class="shadow bg-white">
    <a
      mat-tab-link
      [routerLink]="['./', 'scorecard']"
      routerLinkActive
      #operations="routerLinkActive"
      [active]="operations.isActive"
    >
      <span>Scorecard</span>
    </a>
    <a
      mat-tab-link
      [routerLink]="['./', 'completed']"
      routerLinkActive
      #completed="routerLinkActive"
      [active]="completed.isActive"
    >
      <span>Completed Loads</span>
    </a>
    <a
      mat-tab-link
      [routerLink]="['./', 'profile']"
      routerLinkActive
      #profile="routerLinkActive"
      [active]="profile.isActive"
    >
      <span>Profile</span>
    </a>
    <ng-container *lohiFeatureFlag="'openShiftTimeline'">
      <a
        mat-tab-link
        [routerLink]="['./', 'timeline', currentDriver.inProgressShift.id]"
        *ngIf="currentDriver.inProgressShift"
      >
        Current Shift Timeline
      </a>
    </ng-container>
    <ng-container *lohiFeatureFlag="'grossWeightPermits'">
      <a
        mat-tab-link
        [routerLink]="['./', 'certifications']"
        routerLinkActive
        #certifications="routerLinkActive"
        [active]="certifications.isActive"
      >
        <span>Certifications/Permits</span>
      </a>
    </ng-container>
    <ng-container *lohiFeatureFlag="'safety'">
      <a
        *lohiEarningsProgramMember
        mat-tab-link
        [routerLink]="['./', 'safety']"
        routerLinkActive
        #safety="routerLinkActive"
        [active]="safety.isActive"
      >
        <span>Safety</span>
      </a>
    </ng-container>
  </nav>
  <router-outlet style="background-color: #e5e5e5" class="overflow-hidden"></router-outlet>
</div>
<a *ngIf="backUrl$ | async as url" [routerLink]="url" class="fixed" style="z-index: 100; left: 10px; bottom: 10px">
  <button color="primary" mat-fab><mat-icon class="text-white">keyboard_arrow_left</mat-icon></button>
</a>

<ng-template #coaching>
  <ng-container *ngIf="currentDriver$ | async as driver">
    <div mat-dialog-title>Driver Coaching</div>
    <div mat-dialog-content *ngIf="coachingStatus == 1">
      <div>
        <span
          >{{ driver.driverName }} has had $0 in missed earnings over the past 5 days. He's doing a great job!
        </span>
      </div>
    </div>
    <div mat-dialog-content *ngIf="coachingStatus == 2">
      <div>
        <span>Talk to {{ driver.driverName }} about the driver coaching recommendations on this page. </span>
      </div>
    </div>
    <div mat-dialog-content *ngIf="coachingStatus == 3">
      <div>
        <span>Talk to {{ driver.driverName }} about the driver coaching recommendations on this page. </span>
      </div>
    </div>
    <div mat-dialog-content *ngIf="coachingStatus == 4">
      <div>
        <span>{{ driver.driverName }} is doing great! </span>
      </div>
    </div>
    <ng-container *ngIf="messageDetails$$ | async as messageDetails">
      <div class="my-1 border border-gray-400 p-1">
        <div class="my-1">
          <span class="font-bold">Phone Number:</span> {{ messageDetails.driverPhoneNumber | phone }}
        </div>
        <div class="my-1">
          <div class="font-bold">Suggested Text:</div>
          <div class="bg-gray-300 p-1" (click)="copyText(messageDetails.suggestedText)">
            {{ messageDetails.suggestedText }}
          </div>
        </div>
        <div class="my-1 flex items-center">
          <a mat-stroked-button color="primary" [href]="messageDetails.url">Send Text</a>
          <div class="text-gray-600 pl-2">{{ messageDetails.urlNote }}</div>
        </div>
      </div>
    </ng-container>
    <div mat-dialog-actions class="mt-1 flex justify-between" *ngIf="(messageDetails$$ | async) === null">
      <div></div>
      <a type="button" mat-stroked-button color="primary" (click)="loadSmsMessage()">Get Coaching Text</a>
    </div>
  </ng-container>
</ng-template>

<ng-template #removeUserModal>
  <ng-container *ngIf="currentDriver$ | async as driver">
    <div mat-dialog-title>Remove Driver from {{ (userInfo$ | async)?.companyName }}</div>
    <div mat-dialog-content>
      <div>This driver will no longer be able to sign in to their account.</div>
      <div>
        If you only wish to block them from booking shifts, go to
        <a class="text-blue-500" matDialogClose routerLink="./profile">Profile</a> > Block Shift Booking
      </div>
      <div class="mt-1 font-bold" *lohiFeatureFlag="'notifyDriverWarning'">
        The driver will be notified that they have been removed from your account.
      </div>
      <div class="mt-1 font-bold" *lohiFeatureFlag="'notifyDriverWarning'">
        NOTE: The driver will NOT be able to start shifts and any WEX cards associated with driver will be deactivated.
      </div>
    </div>
    <div mat-dialog-actions class="mt-1 flex justify-between">
      <button mat-button matDialogClose>Close</button>
      <button mat-raised-button color="warn" matDialogClose (click)="removeUser(driver.id)">Remove</button>
    </div>
  </ng-container>
</ng-template>
